// rights of VIEWER
// EDITOR
// ADMIN
// OWNER
// SUPERUSER
// in the database as enum

const roles = {
    VIEWER: 'viewer',
    EDITOR: 'editor',
    ADMIN: 'admin',
    OWNER: 'owner',
    SUPERUSER: 'superuser',
};

const roleColors = {
    owner: '#f48fb1cc',
    editor: '#ffe082cc',
    member: '#ffe082cc',
    admin: '#81c784cc',
    viewer: '#81d4facc',
    superuser: '#f8b620',
};

const role_values = {
    VIEWER: 1,
    viewer: 1,
    EDITOR: 2,
    editor: 2,
    MEMBER: 2,
    member: 2,
    ADMIN: 3,
    admin: 3,
    OWNER: 4,
    owner: 4,
    SUPERUSER: 5,
    superuser: 5,
};

// the description of the individual rights
const role_descriptions = {
    VIEWER: 'Can view the expert and its content',
    EDITOR: 'Can edit the expert and its content',
    ADMIN: 'Can edit the expert and its content and invite other users',
    OWNER: 'Can edit the expert and its content, invite other users and delete the expert',
};

const languages = [
    { name: 'Automatic', display: '✨', hideDisplay: false, lang: 'auto' },
    { name: 'German', display: '🇩🇪', hideDisplay: false, lang: 'de' },
    { name: 'English', display: '🇬🇧', hideDisplay: false, lang: 'en' },
    { name: 'Spanish', display: '🇪🇸', hideDisplay: false, lang: 'es' },
    { name: 'French', display: '🇫🇷', hideDisplay: false, lang: 'fr' },
    { name: 'Turkish', display: '🇹🇷', hideDisplay: false, lang: 'tr' },
];

export const getLanguage = (lang) => {
    return languages.find((l) => l.lang === lang);
};

const pastel_colors = [
    '#c5cae9cc',
    '#f48fb1cc',
    '#ffe082cc',
    '#81c784cc',
    '#81d4facc',
    '#f8bbd0cc',
    '#d1c4e9cc',
    '#c5cae9cc',
    '#bbdefbcc',
    '#b2ebf2cc',
    '#b2dfdbcc',
    '#c8e6c9cc',
    '#f0f4c3cc',
    '#fffde7cc',
    '#ffecb3cc',
    '#ffd180cc',
    '#d7ccc8cc',
    '#eeeeeecc',
    '#cfd8dccc',
];

const chart_colors = [
    '#1ba3c6',
    '#e03426',
    '#f8b620',
    '#57a337',
    '#7873c0',
    '#f06719',
    '#fc719e',
    '#2cb5c0',
    '#eb73b3',
    '#21B087',
    '#f64971',
    '#a2b627',
    '#f89217',
    '#33a65c',
    '#30bcad',
    '#ce69be',
    '#a26dc2',
    '#4f7cba',
    '#d5bb21',
];

const fileCategories = {
    image: ['jpg', 'jpeg', 'png', 'heic', 'bmp', 'tiff'],
    doc: [
        'pdf',
        'docx',
        'txt',
        'text',
        'log',
        'eml',
        'xml',
        'htm',
        'html',
        'md',
        'org',
        'rst',
        'doc',
        'rtf',
        'epub',
        'msg',
        'odt',
    ],
    sheet: ['xlsx', 'xls', 'csv', 'tsv', 'tab'],
    slide: ['pptx', 'ppt'],
    archive: ['zip'],
    audio: ['wav'],
    code: ['js', 'py', 'java', 'cpp', 'cc', 'cxx', 'c', 'cs', 'php', 'rb', 'swift', 'ts', 'go'],
    markup: ['json', 'yaml', 'yml'],
};

const fileIcons = {
    image: 'mdi-image-area',
    doc: 'mdi-file-document',
    sheet: 'mdi-file-excel',
    slide: 'mdi-file-powerpoint',
    archive: 'mdi-folder-zip',
    audio: 'mdi-file-music',
    code: 'mdi-file-code',
    markup: 'mdi-xml',
    folder: 'mdi-folder',
    website: 'mdi-web',
    confluence_site: 'mdi-share-variant',
};

const generatorErrorCode = {
    FILTER: 1,
    UNEXPECTED: 2,
};

export {
    roles,
    roleColors,
    role_descriptions,
    role_values,
    pastel_colors,
    chart_colors,
    fileCategories,
    fileIcons,
    generatorErrorCode,
};
